import { type CSSProperties } from "react";

interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: "sm" | "md" | "lg" | "pill";
  className?: string;
  style?: CSSProperties;
}

export function Skeleton({ width = "100%", height = 12, radius = "sm", className = "", style }: SkeletonProps) {
  const classes = ["sgs-skeleton", `sgs-skeleton--${radius}`];
  if (className) classes.push(className);

  return (
    <span
      className={classes.join(" ")}
      aria-hidden
      style={{
        width: typeof width === "number" ? `${width}px` : width,
        height: typeof height === "number" ? `${height}px` : height,
        ...style
      }}
    />
  );
}
